import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#map-pin-off-clip0_2249_1793)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M1.707.293A1 1 0 0 0 .293 1.707L3.43 4.845A10 10 0 0 0 2 10c0 3.902 2.484 7.396 4.774 9.813a31.4 31.4 0 0 0 4.254 3.726 19 19 0 0 0 .384.27l.023.016.007.005.003.002c.336.224.774.223 1.11 0l.004-.003.009-.006.031-.02.113-.079q.147-.102.41-.293c.347-.255.834-.627 1.404-1.1a30 30 0 0 0 3.261-3.13l4.506 4.506a1 1 0 0 0 1.414-1.414zm14.664 17.492-3.902-3.902A1 1 0 0 1 12 14a4 4 0 0 1-4-4c0-.17.042-.33.117-.47L4.9 6.315A8 8 0 0 0 4 10c0 3.098 2.016 6.104 4.226 8.437A29.4 29.4 0 0 0 12 21.773c.316-.234.748-.565 1.25-.98a28 28 0 0 0 3.12-3.008M12 2a8 8 0 0 0-4 1.072A1 1 0 0 1 7 1.34 10 10 0 0 1 22 10c0 1.762-.508 3.434-1.258 4.945a1 1 0 0 1-1.791-.89C19.603 12.742 20 11.375 20 10a8 8 0 0 0-8-8m-1 5a1 1 0 0 1 1-1 4 4 0 0 1 4 4 1 1 0 1 1-2 0 2 2 0 0 0-2-2 1 1 0 0 1-1-1",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "map-pin-off-clip0_2249_1793" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }